var _rect, _path, _path2, _path3, _rect2, _rect3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoAudifonos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 54.5,
    width: 11,
    height: 7,
    rx: 3.5,
    fill: "white",
    stroke: "#545E62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 55V61.5",
    stroke: "#545E62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 55V61.5",
    stroke: "#545E62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 58H48C51.3137 58 54 55.3137 54 52V49",
    stroke: "#545E62"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 32.5,
    width: 8,
    height: 16,
    rx: 3.5,
    fill: "white",
    stroke: "#545E62"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 32.5,
    width: 8,
    height: 16,
    rx: 3.5,
    fill: "white",
    stroke: "#545E62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8429 36.1714V31.7821C52.8429 22.8399 45.5938 15.5909 36.6517 15.5909H35.7782H35.0525C26.1104 15.5909 18.8613 22.8399 18.8613 31.7821V36.3193C18.8613 37.5237 17.885 38.5 16.6807 38.5C15.4763 38.5 14.5 37.5237 14.5 36.3193V31.3333C14.5 20.3797 23.3797 11.5 34.3333 11.5H37.6667C48.6203 11.5 57.5 20.3797 57.5 31.3333V36.1714C57.5 37.4575 56.4575 38.5 55.1714 38.5C53.8854 38.5 52.8429 37.4575 52.8429 36.1714Z",
    fill: "white",
    stroke: "#545E62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 40.5C8 35.2533 12.2533 31 17.5 31H20.037C20.5689 31 21 31.4311 21 31.963V49.037C21 49.5689 20.5689 50 20.037 50H17.5C12.2533 50 8 45.7467 8 40.5Z",
    fill: "#0099CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64 40.5C64 35.2533 59.7467 31 54.5 31H51.963C51.4311 31 51 31.4311 51 31.963V49.037C51 49.5689 51.4311 50 51.963 50H54.5C59.7467 50 64 45.7467 64 40.5Z",
    fill: "#0099CC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAudifonos);
export default __webpack_public_path__ + "static/media/ico_audifonos.19d10ec82eb0c8cf2c9bf60f52f48c69.svg";
export { ForwardRef as ReactComponent };